/* Osmanlı Doğal Taş — Üyelik Statü Programı (vitrin katmanı)
   ------------------------------------------------------------------
   Veri: window.ODT_STATU (snippets/odt-statu.liquid; iki metafield'dan gelir).
   Ne yapar:
     1) Başlıkta hesap ikonunun yanına kademe rozeti (giriş yapmış müşteri).
     2) Ürün sayfasında fiyatın altına statü satırı (kademeli: bu üründe indirim;
        üye: sonraki kademeye kalan; ziyaretçi: kısa tanıtım + giriş).
     3) Sepette (çekmece + sepet sayfası) statü satırı: uygulanacak indirim, bir
        üst basamağa kalan tutar; üyeye "bu siparişle kademe atlarsın" bilgisi.
     4) Kademe kodunu SESSİZCE uygular: /discount/<KOD> Shopify'ın kendi ucudur,
        ödeme sayfasında kodu kendiliğinden kullanır. Kod segmente kısıtlı olduğu
        için etiketsiz müşteride zaten çalışmaz; güvenlik bu betiğe bağlı DEĞİL.
   Basamak tablosu ve kademe adları panelden gelir; burada sabit sayı yok.
*/
(function (g, d) {
  "use strict";
  var C = g.ODT_STATU; if (!C || !C.ayar || !C.ayar.aktif) return;
  var A = C.ayar, M = C.musteri;
  var SEV = {}; (A.seviyeler || []).forEach(function (s) { SEV[s.kod] = s; });
  var SIRA = { "": 0, gumus: 1, altin: 2, platin: 3 };
  var SAYFA = A.sayfa || "/pages/statu";
  var ANAHTAR = "odt_statu_kod_v1";

  function ikon(sev, px) {
    var u = sev ? (SEV[sev] && SEV[sev].ikon) : A.uye_ikon;
    if (!u) return sev ? "◆ " : "◇ ";
    return "<img class=\"odt-st-ikon\" src=\"" + esc(u) + "?width=" + (px * 2) + "\" width=\"" + px + "\" height=\"" + px + "\" alt=\"\">";
  }
  function tl(n) { try { return Math.floor(n).toLocaleString("tr-TR"); } catch (e) { return String(Math.floor(n)); } }
  function esc(t) { return String(t == null ? "" : t).replace(/[&<>"']/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; }); }

  /* Müşterinin kademesi: metafield birincil, etiket yedek. */
  function kademe() {
    if (!M) return "";
    var s = (M.durum && M.durum.seviye) || M.etiket || "";
    return SEV[s] ? s : "";
  }
  function durum() { return (M && M.durum) || null; }

  /* Sepet ara toplamına (kuruş) göre bu kademenin basamağı → [basamakTL, indirimTL, sonrakiBasamak, sonrakiIndirim] */
  function basamak(sev, kurus) {
    var s = SEV[sev]; if (!s) return null;
    var toplam = kurus / 100, sec = null, sonraki = null;
    (s.basamak || []).forEach(function (b) {
      if (toplam >= b[0]) { if (!sec || b[0] > sec[0]) sec = b; }
      else if (!sonraki || b[0] < sonraki[0]) sonraki = b;
    });
    return { simdi: sec, sonraki: sonraki, kod: sec ? (s.kod_oneki + "-" + sec[0]) : "" };
  }
  function sonrakiKademe(sev) {
    var en = null;
    (A.seviyeler || []).forEach(function (s) { if (SIRA[s.kod] > (SIRA[sev] || 0) && (!en || SIRA[s.kod] < SIRA[en.kod])) en = s; });
    return en;
  }

  /* ---------- 1) rozet ---------- */
  function rozet() {
    if (!M || d.querySelector(".odt-st-pill")) return;
    var sev = kademe();
    /* DİKKAT: yerel değişken adı amblem fonksiyonu ikon() ile ÇAKIŞMASIN (bir kez çakıştı, giriş yapmış müşteride betik durdu) */
    var hesap = d.querySelector(".header-icon-account");
    if (!hesap || !hesap.parentNode) return;
    var a = d.createElement("a");
    a.className = "odt-st-pill"; a.href = SAYFA;
    a.setAttribute("aria-label", "Üyelik statün");
    a.innerHTML = ikon(sev, 15) + (sev ? esc(SEV[sev].ad) : "Üye");
    hesap.parentNode.insertBefore(a, hesap.nextSibling);
  }

  /* ---------- 2) ürün sayfası ---------- */
  function urunSatiri() {
    if (C.sablon !== "product" || d.querySelector(".odt-st-urun")) return;
    var fiyatKutu = null;
    /* Tek-ekran ürün şablonunda (otk) fiyat satırı .otk-prow; klasik tema şablonunda .price */
    var otk = d.querySelector(".otk .otk-prow");
    if (otk) {
      var kutuO = d.createElement("div"); kutuO.className = "odt-st-satir odt-st-urun"; kutuO.innerHTML = urunHtml();
      if (!kutuO.innerHTML) return;
      otk.parentNode.insertBefore(kutuO, otk.nextSibling); return;
    }
    var adaylar = d.querySelectorAll("main .price, .product-info .price, [class*='product'] .price");
    for (var i = 0; i < adaylar.length; i++) {
      var el = adaylar[i]; if (el.closest && el.closest(".odt-st-urun")) continue;
      var r = el.getBoundingClientRect();
      if (r.width > 40 && /TL/.test(el.textContent || "")) { fiyatKutu = el; break; }
    }
    if (!fiyatKutu) return;
    var html = urunHtml();
    if (!html) return;
    var kutu = d.createElement("div"); kutu.className = "odt-st-satir odt-st-urun"; kutu.innerHTML = html;
    var hedef = fiyatKutu.parentNode && fiyatKutu.parentNode.classList && fiyatKutu.parentNode.classList.contains("price") ? fiyatKutu.parentNode : fiyatKutu;
    hedef.parentNode.insertBefore(kutu, hedef.nextSibling);
  }
  function urunHtml() {
    var sev = kademe(), html = "";
    var fiyat = typeof C.urunFiyat === "number" ? C.urunFiyat : null;
    if (!M) {
      var ilk = (A.seviyeler || [])[0], ilkTutar = ilk && ilk.basamak && ilk.basamak[0] ? ilk.basamak[0][1] : 0;
      html = ikon("", 18) + "<b>Üyelik statüsü:</b> alışverişlerin biriktikçe sepette " + (ilkTutar ? tl(ilkTutar) + " TL'den başlayan " : "") +
             "indirim. <a href=\"" + esc(C.giris) + "\">Giriş yap</a> · <a href=\"" + esc(SAYFA) + "\">Nasıl çalışır?</a>";
    } else if (sev) {
      var b = basamak(sev, fiyat || 0);
      if (b && b.simdi) {
        html = ikon(sev, 18) + "<b>" + esc(SEV[sev].ad) + " üye indirimin:</b> bu ürün sepette <b>" + tl(b.simdi[1]) + " TL</b> daha ucuz, ödeme sayfasında kendiliğinden düşer." +
               (b.sonraki ? "<span class=\"odt-st-alt\">" + tl(b.sonraki[0]) + " TL ve üzeri sepette indirim " + tl(b.sonraki[1]) + " TL olur.</span>" : "");
      } else if (b && b.sonraki) {
        html = ikon(sev, 18) + "<b>" + esc(SEV[sev].ad) + " üyesin:</b> " + tl(b.sonraki[0]) + " TL ve üzeri sepette <b>" + tl(b.sonraki[1]) + " TL</b> statü indirimi, ödeme sayfasında kendiliğinden.";
      }
    } else {
      var du = durum(), sk = sonrakiKademe("");
      if (sk) {
        var kalan = du && typeof du.kalan === "number" ? du.kalan : sk.esik;
        html = ikon("", 18) + "<b>Üye:</b> <b>" + esc(sk.ad) + "</b> statüye " + tl(kalan) + " TL kaldı; sonra her siparişte sabit indirin. <a href=\"" + esc(SAYFA) + "\">Statü sayfan</a>";
      }
    }
    return html;
  }

  /* ---------- 3) sepet ---------- */
  function sepetOku() {
    return fetch("/cart.js", { headers: { "Accept": "application/json" }, credentials: "same-origin" })
      .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
  }
  function sepetKutulari() {
    var out = [];
    d.querySelectorAll(".cart-drawer-price-total, #main-cart-footer .cart__footer, .cart__footer, [id^='main-cart-footer'] .cart-footer-block").forEach(function (k) { out.push(k); });
    d.querySelectorAll("button[name='checkout'], a[href='/checkout'], form[action='/checkout']").forEach(function (b) {
      var k = b.closest ? (b.closest(".cart-drawer-price-total") || b.closest("form") || b.parentNode) : b.parentNode;
      if (k && out.indexOf(k) < 0) out.push(k);
    });
    return out;
  }
  function sepetHtml(sepet) {
    if (!sepet || !sepet.items || !sepet.items.length) return "";
    var kurus = 0;
    sepet.items.forEach(function (it) { kurus += (typeof it.final_line_price === "number") ? it.final_line_price : it.line_price; });
    var sev = kademe(), du = durum();
    if (!M) {
      var ilk = (A.seviyeler || [])[0];
      return ikon("", 18) + "<b>Üyelik statüsü:</b> üyeler bu sepette " + (ilk && ilk.basamak && ilk.basamak[0] ? "en az " + tl(ilk.basamak[0][1]) + " TL " : "") +
             "statü indirimi alır. <a href=\"" + esc(C.giris) + "\">Giriş yap</a>";
    }
    if (sev) {
      var b = basamak(sev, kurus);
      var h = "";
      if (b && b.simdi) {
        h = ikon(sev, 18) + "<b>" + esc(SEV[sev].ad) + " statü indirimin:</b> <b class=\"odt-st-tutar\">−" + tl(b.simdi[1]) + " TL</b>, ödeme sayfasında kendiliğinden uygulanır.";
        if (b.sonraki) h += "<span class=\"odt-st-alt\">" + tl(b.sonraki[0] - kurus / 100) + " TL daha ekle → indirim " + tl(b.sonraki[1]) + " TL olsun.</span>";
      } else if (b && b.sonraki) {
        h = ikon(sev, 18) + "<b>" + esc(SEV[sev].ad) + " üyesin:</b> sepet " + tl(b.sonraki[0]) + " TL'yi geçince <b>" + tl(b.sonraki[1]) + " TL</b> statü indirimi düşer (" + tl(b.sonraki[0] - kurus / 100) + " TL kaldı).";
      }
      return h;
    }
    var sk = sonrakiKademe("");
    if (!sk) return "";
    var harcama = du && typeof du.harcama === "number" ? du.harcama : 0;
    var kalan = Math.max(0, sk.esik - harcama);
    var yuzde = Math.max(3, Math.min(100, Math.round(((harcama + kurus / 100) / sk.esik) * 100)));
    if (harcama + kurus / 100 >= sk.esik) {
      return ikon(sk.kod, 18) + "<b>Bu siparişle " + esc(sk.ad) + " üye olursun:</b> sonraki her siparişte sabit statü indirimi. <a href=\"" + esc(SAYFA) + "\">Haklar</a>" +
             "<span class=\"odt-st-cubuk\"><i style=\"width:100%\"></i></span>";
    }
    return ikon("", 18) + "<b>" + esc(sk.ad) + " statüye " + tl(Math.max(0, kalan - kurus / 100)) + " TL kaldı</b> (bu sepet dahil). <a href=\"" + esc(SAYFA) + "\">Nasıl çalışır?</a>" +
           "<span class=\"odt-st-cubuk\"><i style=\"width:" + yuzde + "%\"></i></span>";
  }
  var sonSepetHtml = null;
  function sepetCiz(sepet) {
    var html = sepetHtml(sepet);
    sepetKutulari().forEach(function (k) {
      var v = k.querySelector(":scope > .odt-st-sepet");
      if (!html) { if (v) v.parentNode.removeChild(v); return; }
      if (!v) { v = d.createElement("div"); v.className = "odt-st-satir odt-st-sepet"; k.insertBefore(v, k.firstChild); }
      if (v.getAttribute("data-html") !== html) { v.innerHTML = html; v.setAttribute("data-html", html); }
    });
    sonSepetHtml = html;
  }

  /* ---------- 4) kodu sessizce uygula ---------- */
  var sonKod = null;
  function koduUygula(sepet) {
    var sev = kademe(); if (!sev || !sepet || !sepet.items) return;
    var kurus = 0; sepet.items.forEach(function (it) { kurus += (typeof it.final_line_price === "number") ? it.final_line_price : it.line_price; });
    var b = basamak(sev, kurus); var kod = b && b.kod ? b.kod : "";
    if (!kod) return;
    if (sonKod === null) { try { sonKod = g.sessionStorage.getItem(ANAHTAR) || ""; } catch (e) { sonKod = ""; } }
    if (kod === sonKod) return;
    /* Shopify'ın kendi ucu: indirim çerezini yazar, ödeme sayfası kodu uygular. Yönlendirmeyi takip etmeye gerek yok. */
    fetch("/discount/" + encodeURIComponent(kod) + "?redirect=%2Fcart", { credentials: "same-origin", redirect: "follow" })
      .then(function () { sonKod = kod; try { g.sessionStorage.setItem(ANAHTAR, kod); } catch (e) {} })
      .catch(function () {});
  }

  /* ---------- tetikleyiciler ---------- */
  var mesgul = false, bekleyen = false;
  function guncelle() {
    if (mesgul) { bekleyen = true; return; }
    mesgul = true;
    sepetOku().then(function (sepet) {
      mesgul = false;
      if (sepet) { sepetCiz(sepet); koduUygula(sepet); }
      if (bekleyen) { bekleyen = false; setTimeout(guncelle, 250); }
    });
  }
  function yerlestir() { rozet(); urunSatiri(); if (sonSepetHtml !== null) { sepetKutulari().forEach(function (k) { if (sonSepetHtml && !k.querySelector(":scope > .odt-st-sepet")) { var v = d.createElement("div"); v.className = "odt-st-satir odt-st-sepet"; v.innerHTML = sonSepetHtml; v.setAttribute("data-html", sonSepetHtml); k.insertBefore(v, k.firstChild); } }); } }

  function basla() {
    yerlestir(); guncelle();
    /* Tema sepeti kendisi yeniden çizer (bölüm yenileme); satırımızı yeniden yerleştir + sepet değişince yeniden oku. */
    try {
      var of = g.fetch;
      g.fetch = function () {
        var u = arguments[0]; u = u && (u.url || u);
        var p = of.apply(this, arguments);
        if (typeof u === "string" && /\/cart\/(add|change|update|clear)/.test(u)) { p.then(function () { setTimeout(guncelle, 350); }, function () {}); }
        return p;
      };
    } catch (e) {}
    d.addEventListener("submit", function (ev) { var f = ev.target; if (f && f.action && String(f.action).indexOf("/cart/add") > -1) setTimeout(guncelle, 900); }, true);
    var zam = null;
    try {
      new MutationObserver(function () { if (zam) return; zam = setTimeout(function () { zam = null; yerlestir(); }, 200); })
        .observe(d.body, { childList: true, subtree: true });
    } catch (e) {}
    /* Çekmece açılışında sepet hâlâ eski olabilir; birkaç saniyelik seyrek emniyet ağı. */
    setTimeout(guncelle, 3000); setTimeout(guncelle, 12000);
  }
  if (d.readyState === "loading") d.addEventListener("DOMContentLoaded", basla); else basla();
})(window, document);
